import { render, staticRenderFns } from "./header.vue?vue&type=template&id=a53d083c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "@/scss/common.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./header.vue?vue&type=style&index=1&id=a53d083c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53d083c",
  null
  
)

export default component.exports